'use strict';

import debounce from 'shared/js/util/debounce';
import { VOYADO_INITIALIZE } from 'shared/js/voyadoEventNames';

const util = require('improove/util/util');
var previousScreenSize = util.getScreenSize();

function focusEl(selector) {
    var el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (el && typeof el.focus === 'function') {
        el.focus({ preventScroll: true });
    }
}

/**
 * Hides/unhides all body children from screen readers except the OneTrust
 * banner container so that mobile SR focus stays inside the dialog.
 */
function setPageInertForBanner(hide) {
    var bannerRoot = document.getElementById('onetrust-consent-sdk');
    if (!bannerRoot) return;

    Array.prototype.forEach.call(document.body.children, function (child) {
        if (child === bannerRoot || child.tagName === 'SCRIPT' || child.tagName === 'LINK') return;
        if (hide) {
            child.setAttribute('aria-hidden', 'true');
            child.inert = true;
        } else {
            child.removeAttribute('aria-hidden');
            child.inert = false;
        }
    });
}

/**
 * Watches the OneTrust banner element for visibility changes and
 * toggles aria-hidden / inert on the rest of the page accordingly.
 */
function initOneTrustScreenReaderTrap() {
    var observer = new MutationObserver(function () {
        var banner = document.getElementById('onetrust-banner-sdk');
        var pcPanel = document.getElementById('onetrust-pc-sdk');
        var isVisible =
            (banner && banner.style.display !== 'none' && !banner.classList.contains('ot-hide')) ||
            (pcPanel && pcPanel.style.display !== 'none' && !pcPanel.classList.contains('ot-hide'));
        setPageInertForBanner(!!isVisible);
    });

    function tryObserve() {
        var sdk = document.getElementById('onetrust-consent-sdk');
        if (sdk) {
            observer.observe(sdk, { attributes: true, childList: true, subtree: true });
            var banner = document.getElementById('onetrust-banner-sdk');
            if (banner && banner.style.display !== 'none' && !banner.classList.contains('ot-hide')) {
                setPageInertForBanner(true);
                $('body').addClass('no-scroll');
                setTimeout(() => {
                    focusEl('#onetrust-accept-btn-handler');
                }, 1000);
            }
        } else {
            setTimeout(tryObserve, 500);
        }
    }

    tryObserve();
}

function setCookie(key, value, expiresInDays) {
    var date = new Date();
    date.setTime(date.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/;expires=' + date.toUTCString();
}

function deleteCookie(name) {
    document.cookie = name + '=1;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// For the removal of the cookies that have different domain
function eraseCookie(name) {
    var domain = window.location.hostname;
    domain = domain.substring(domain.indexOf('.'));
    document.cookie = name + '=1;domain=' + domain + ';path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function injectGTMScript() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var firstScript = document.getElementsByTagName('script')[0];
    var scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = '//' + window.GTM_URL + '/gtm.js?id=' + window.GTM_CONTAINER_ID;
    firstScript.parentNode.insertBefore(scriptElement, firstScript);
}

function setInitialValues() {
    // Inject GTM script after defining the default and inital updated consent values
    if (window.GTM_ENABLED && window.GTM_CONTAINER_ID) {
        injectGTMScript();
    }
}

const execute = function () {
    $(window).on(
        'load resize',
        debounce(function () {
            var currentScreenSize = util.getScreenSize();
            if (previousScreenSize != currentScreenSize) {
                previousScreenSize = currentScreenSize;
            }
        }));

    $('[data-dynamic-message-banner] .close-banner-icon').click(function () {
        $('[data-dynamic-message-banner]').addClass('hide');
        const isAuthenticatedUser = $('#isAuthenticatedUser').length > 0;
        if (!isAuthenticatedUser) {
            // One will expire in 1 day, other when session ends
            setCookie('show_dynamic_message_banner', false, 1);
            setCookie('show_dynamic_message_banner_session', false);
        } else {
            setCookie('show_dynamic_message_banner_logged', false, 1);
            setCookie('show_dynamic_message_banner_logged_session', false);
        }
    });

    /* BIG COOKIE BANNER */
    // #CDIFF PF <> FM <> GG - has 2d part of condition, is used PF version
    const isBraveBrowser = navigator.brave ? navigator.brave.isBrave() : false;
    if (document.cookie.indexOf('set_necessary_cookies=1') < 0 && !$('.cookie-message-banner').hasClass('old-cookie-banner') && !isBraveBrowser) {
        $('.cookie-message-banner').removeClass('hide');
        $('.cookie-banner-overlay').removeClass('hide');
    }

    $('[data-view-cookie-details]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('.cookie-message-banner').addClass('hide');
        $('.cookie-details-wrapper').removeClass('hide');
        $('.close-banner-icon').trigger('focus');
    });

    $('[data-open-cookie-policy]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('.cookie-details-wrapper').addClass('hide');
        $('.cookie-message-banner').addClass('hide');
        $('.cookie-policy-wrapper').removeClass('hide');
    });

    $('[data-open-integritets-policy]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('.cookie-details-wrapper').addClass('hide');
        $('.cookie-message-banner').addClass('hide');
        $('.cookie-integrity-wrapper').removeClass('hide');
    });

    $('[data-return-to-banner]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('.cookie-message-banner').removeClass('hide');
        $('.cookie-details-wrapper').addClass('hide');
        $('.cookie-policy-wrapper').addClass('hide');
        $('.cookie-integrity-wrapper').addClass('hide');
        $('.save-cookie-button').trigger('focus');
    });

    $('.cookie-message-banner .save-cookie-button ').on('click', function () {
        setCookie('set_necessary_cookies', 1, 365);
        setCookie('set_functional_cookies', 1, 365);
        setCookie('set_analytics_cookies', 1, 365);
        setCookie('set_marketing_cookies', 1, 365);
        $('.cookie-message-banner').addClass('hide');
        $('.cookie-banner-overlay').addClass('hide');
        document.dispatchEvent(new CustomEvent(VOYADO_INITIALIZE));
    });

    $('[data-save-all-cookies]').on('click', function () {
        $('.cookie-checkbox').each(function () {
            if ($(this).is(':checked') !== true) {
                $(this).prop('checked', true);
            }
        });
        setCookie('set_necessary_cookies', 1, 365);
        setCookie('set_functional_cookies', 1, 365);
        setCookie('set_analytics_cookies', 1, 365);
        setCookie('set_marketing_cookies', 1, 365);
        $('.cookie-details-wrapper').addClass('hide');
        $('.cookie-banner-overlay').addClass('hide');
    });

    $('[data-deny-all-cookies], .cookie-message-banner .save-necessary-cookie-button').on('click', function () {
        $('.cookie-checkbox').each(function () {
            if ($(this).is(':checked') && $(this).is(':disabled') !== true) {
                $(this).prop('checked', false);
            }
        });
        setCookie('set_necessary_cookies', 1, 365);
        $('.cookie-message-banner').addClass('hide');
        $('.cookie-details-wrapper').addClass('hide');
        $('.cookie-banner-overlay').addClass('hide');
    });

    $('[data-save-cookies]').on('click', function () {
        setCookie('set_necessary_cookies', 1, 365);

        if ($('#cookie-checkbox-functional').is(':checked')) {
            setCookie('set_functional_cookies', 1, 365);
        }

        if ($('#cookie-checkbox-analytics').is(':checked')) {
            setCookie('set_analytics_cookies', 1, 365);
        }

        if ($('#cookie-checkbox-marketing').is(':checked')) {
            setCookie('set_marketing_cookies', 1, 365);
        }

        $('.cookie-details-wrapper').addClass('hide');
        $('.cookie-banner-overlay').addClass('hide');
    });

    $('[data-reset-cookies]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (document.cookie.indexOf('set_necessary_cookies=1') >= 0) {
            deleteCookie('set_necessary_cookies');
        }

        if (document.cookie.indexOf('set_functional_cookies=1') >= 0) {
            deleteCookie('set_functional_cookies');
        }

        if (document.cookie.indexOf('set_analytics_cookies=1') >= 0) {
            deleteCookie('set_analytics_cookies');
        }

        if (document.cookie.indexOf('set_marketing_cookies=1') >= 0) {
            deleteCookie('set_marketing_cookies');
        }

        if (document.cookie.indexOf('sg_optin=1') >= 0) {
            eraseCookie('sg_optin');
        }

        if ($('.cookie-message-banner').length > 0) {
            $('.cookie-message-banner').addClass('hide');
            $('.cookie-details-wrapper').removeClass('hide');
            $('.cookie-bar-logo').trigger('focus');
        }
    });

    // index.js already triggers cookie:update on load and its handler isn't idempotent (Dixa init,
    // Voyado script injection), so only forward consent the shopper actually changes afterwards.
    // OneTrust doesn't guarantee the same group order across e.detail and OnetrustActiveGroups.
    var normalizeOneTrustGroups = function (groups) {
        return (Array.isArray(groups) ? groups : String(groups || '').split(',')).filter(Boolean).sort().join(',');
    };
    var lastOneTrustGroups;
    var watchOneTrustConsent = function () {
        if (!window.OneTrust || typeof window.OneTrust.OnConsentChanged !== 'function') {
            return;
        }
        window.removeEventListener('OneTrustGroupsUpdated', watchOneTrustConsent);
        lastOneTrustGroups = normalizeOneTrustGroups(window.OnetrustActiveGroups);

        window.OneTrust.OnConsentChanged(function (e) {
            var groups = normalizeOneTrustGroups((e && e.detail) || window.OnetrustActiveGroups);

            if (groups !== lastOneTrustGroups) {
                lastOneTrustGroups = groups;
                $(document).trigger('cookie:update');
            }
        });
    };

    window.addEventListener('OneTrustGroupsUpdated', watchOneTrustConsent);
    watchOneTrustConsent();

    if (document.cookie.indexOf('set_marketing_cookies=1') > 0) {
        $('#cookie-checkbox-marketing').prop('checked', true);
    }
    if (document.cookie.indexOf('set_functional_cookies=1') > 0) {
        $('#cookie-checkbox-functional').prop('checked', true);
    }
    if (document.cookie.indexOf('set_analytics_cookies=1') > 0) {
        $('#cookie-checkbox-analytics').prop('checked', true);
    }

    // Moved from the initial version of gtmConsent.isml
    $(document).ready(function () {
        setInitialValues();
        initOneTrustScreenReaderTrap();

        function focusEl(selector) {
            var el = typeof selector === 'string' ? document.querySelector(selector) : selector;
            if (el && typeof el.focus === 'function') {
                el.focus({ preventScroll: true });
            }
        }

        // Focus on the cookie banner if it's visible on page load
        if ($('.cookie-message-banner:not(.hide)').length > 0) {
            setTimeout(() => {
                focusEl('.save-cookie-button');
            }, 500);
        } else {
            setTimeout(() => {
                focusEl('.focus-start');
            }, 500);
        }

        // OneTrust banner actions container buttons
        $(document).on('click', '.banner-actions-container button, #accept-recommended-btn-handler, .ot-btn-container button', function () {
            setPageInertForBanner(false);
            $('body').removeClass('no-scroll');
            setTimeout(() => {
                focusEl('.focus-start');
            }, 1000);
        });

        // Update Consent Settings On Cookie Settings Clicks
        $('.cookie-message-banner .save-cookie-button, [data-save-all-cookies]').on('click', function () {
            window.gtag('consent', 'update', {
                ad_storage: 'granted',
                ad_personalization: 'granted',
                ad_user_data: 'granted',
                analytics_storage: 'granted',
                functionality_storage: 'granted',
            });

            document.dispatchEvent(
                new CustomEvent('GTM-push-consent-update',
                    {
                        detail: {
                            event: 'cookie_consent_update'
                        }
                    })
            );
        });

        $('[data-deny-all-cookies], .cookie-message-banner .save-necessary-cookie-button').on('click', function () {
            window.gtag('consent', 'update', {
                ad_storage: 'denied',
                ad_personalization: 'denied',
                ad_user_data: 'denied',
                analytics_storage: 'denied',
                functionality_storage: 'denied',
            });

            document.dispatchEvent(
                new CustomEvent('GTM-push-consent-update',
                    {
                        detail: {
                            event: 'cookie_consent_update'
                        }
                    })
            );
        });

        $('[data-save-cookies]').on('click', function () {
            var analytics_storage = 'denied';
            var ad_storage = 'denied';
            var ad_personalization = 'denied';
            var ad_user_data = 'denied';
            var functionality_storage = 'denied';

            if ($('#cookie-checkbox-analytics').is(':checked')) {
                analytics_storage = 'granted';
            }

            if ($('#cookie-checkbox-marketing').is(':checked')) {
                ad_storage = 'granted';
                ad_personalization = 'granted';
                ad_user_data = 'granted';
            }

            if ($('#cookie-checkbox-functional').is(':checked')) {
                functionality_storage = 'granted';
            }

            window.gtag('consent', 'update', {
                ad_storage: ad_storage,
                ad_personalization: ad_personalization,
                ad_user_data: ad_user_data,
                analytics_storage: analytics_storage,
                functionality_storage: functionality_storage
            });

            document.dispatchEvent(
                new CustomEvent('GTM-push-consent-update',
                    {
                        detail: {
                            event: 'cookie_consent_update'
                        }
                    })
            );
        });

        $('.cookie-message-banner button, .cookie-details-wrapper button').on('click', function () {
            $(document).trigger('cookie:update');
        });
    });
};

module.exports = (context) => {
    if (context === 'checkout') {
        setInitialValues();
        return;
    }
    execute();
};
